<template>
  <section :class="`style-guide-section || constrain-width`">
    <h2>{{ title }}</h2>
    <hr class="style-guide-line" />
    <slot></slot>
  </section>
</template>
<script>
export default {
  name: "style-guide-section",
  props: {
    title: String,
    extraClassNames: [],
  },
};
</script>
